import React from 'react';
import ServicesHero from '../components/ServicesHero';
import ServiceApproach from '../components/ServiceApproach';
import AwardsRecognitions from '../components/AwardsRecognitions';
import BrandLogosSlider from '../components/BrandLogosSlider';
import Services from '../components/Services';
import IndustryGrid from '../components/IndustryGrid';
import ContactUs from '../components/ContactUs';

function ServicesPage({ setView }) {
  return (
    <>
      <ServicesHero />
      <ServiceApproach />
      <AwardsRecognitions />
      <BrandLogosSlider />
      <Services setView={setView} />
      <IndustryGrid />
      <ContactUs />
    </>
  );
}

export default ServicesPage;
